<template>
    <div class="na-form">
        <div v-if="suchfeldDetail" class="left">
            <DxTabPanel>
                <DxItem title="Basisdaten">
                    <div class="na-fieldset naCol1">
                        <div class="na-field">
                            <div class="na-field-label">ID:</div>
                            <div class="na-field-value">
                                <DxTextBox :value='suchfeldDetail.LitId' :disabled="true" />
                            </div>
                        </div>
                        <div class="na-field naLarge">
                            <div class="na-field-label">Name:</div>
                            <div class="na-field-value">
                                <DxTextBox v-model:value='suchfeldDetail.LitName' />
                            </div>
                            
                            <div class="na-description">
                                <div class="na-field-required">*</div>
                                <div class="na-field-description"></div>
                            </div>
                        </div>
                        <div class="na-field naLarge">
                            <div class="na-field-label">Short Name:</div>
                            <div class="na-field-value">
                                <DxTextBox v-model:value='suchfeldDetail.LitShortName' />
                            </div>

                            
                        </div>
                        <div class="na-field naLarge">
                            <div class="na-field-label">Aktiviert:</div>
                            <div class="na-field-value">
                                <DxCheckBox v-model:value='suchfeldDetail.SufEnabled' />
                            </div>
                            <div class="na-description">
                                <div class="na-field-required">*</div>
                                <div class="na-field-description"></div>
                            </div>
                        </div>
                        <div class="na-field">
                            <div class="na-field-label">Kurzbeschreibung:</div>
                            <div class="na-field-value">

                                <DxHtmlEditor class="html-na-field"
                                              v-model:value="suchfeldDetail.SufDescription"
                                              value-type="html">
                                    <DxToolbar>
                                        <DxItem name="undo" />
                                        <DxItem name="redo" />
                                        <DxItem name="separator" />
                                        <DxItem name="orderedList" />
                                        <DxItem name="bulletList" />
                                        <DxItem name="separator" />
                                        <DxItem name="bold" />
                                        <DxItem name="italic" />
                                        <DxItem name="strike" />
                                        <DxItem name="underline" />
                                        <DxItem name="separator" />
                                        <DxItem name="alignLeft" />
                                        <DxItem name="alignCenter" />
                                        <DxItem name="alignRight" />
                                        <DxItem name="alignJustify" />
                                        <DxItem name="separator" />
                                        <DxItem name="color" />
                                        <DxItem name="background" />
                                        <DxItem name="link" />
                                        <DxItem name="image" />
                                        <DxItem name="separator" />
                                        <DxItem name="clear" />
                                        <DxItem name="codeBlock" />
                                        <DxItem name="blockquote" />
                                        <DxItem name="separator" />
                                        <DxItem name="insertTable" />
                                        <DxItem name="deleteTable" />
                                        <DxItem name="insertRowAbove" />
                                        <DxItem name="insertRowBelow" />
                                        <DxItem name="deleteRow" />
                                        <DxItem name="insertColumnLeft" />
                                        <DxItem name="insertColumnRight" />
                                        <DxItem name="deleteColumn" />
                                    </DxToolbar>
                                </DxHtmlEditor>
                            </div>
                        </div>
                        <div class="na-field">
                            <div class="na-field-label">Ausführliche Beschreibung:</div>
                            <div class="na-field-value">
                                <DxHtmlEditor class="html-na-field"
                                              v-model:value="suchfeldDetail.SufLongDescription"
                                              value-type="html">
                                    <DxToolbar>
                                        <DxItem name="undo" />
                                        <DxItem name="redo" />
                                        <DxItem name="separator" />
                                        <DxItem name="orderedList" />
                                        <DxItem name="bulletList" />
                                        <DxItem name="separator" />
                                        <DxItem name="bold" />
                                        <DxItem name="italic" />
                                        <DxItem name="strike" />
                                        <DxItem name="underline" />
                                        <DxItem name="separator" />
                                        <DxItem name="alignLeft" />
                                        <DxItem name="alignCenter" />
                                        <DxItem name="alignRight" />
                                        <DxItem name="alignJustify" />
                                        <DxItem name="separator" />
                                        <DxItem name="color" />
                                        <DxItem name="background" />
                                        <DxItem name="link" />
                                        <DxItem name="image" />
                                        <DxItem name="separator" />
                                        <DxItem name="clear" />
                                        <DxItem name="codeBlock" />
                                        <DxItem name="blockquote" />
                                        <DxItem name="separator" />
                                        <DxItem name="insertTable" />
                                        <DxItem name="deleteTable" />
                                        <DxItem name="insertRowAbove" />
                                        <DxItem name="insertRowBelow" />
                                        <DxItem name="deleteRow" />
                                        <DxItem name="insertColumnLeft" />
                                        <DxItem name="insertColumnRight" />
                                        <DxItem name="deleteColumn" />
                                    </DxToolbar>
                                </DxHtmlEditor>
                            </div>
                            <div class="na-description">
                                <div class="na-field-required">*</div>
                                <div class="na-field-description"></div>
                            </div>
                        </div>
                        <div class="na-field">
                            <div class="na-field-label">Keywords:</div>
                            <div class="na-field-value">
                                <div class="naKeyWords">
                                    <DxTagBox v-model:value='keyWords'
                                              :accept-custom-value="true"
                                              :search-enabled="false"
                                              @onCustomItemCreating="onCustomItemCreating" />
                                </div>
                            </div>
                        </div>
                        <div class="na-field">
                            <div class="na-field-label">Geändert am:</div>
                            <div class="na-field-value">
                                <DxDateBox :value='suchfeldDetail.SufChangedOn' :readOnly="true" />
                            </div>
                        </div>
                        <div class="na-field">
                            <div class="na-field-label">Geändert von:</div>
                            <div class="na-field-value">
                                <DxTextBox :value='suchfeldDetail.SufChangedBy' :readOnly="true" />
                            </div>
                        </div>
                        <div class="na-field">
                            <div class="na-field-label">Erstellt am:</div>
                            <div class="na-field-value">
                                <DxDateBox :value='suchfeldDetail.SufCreatedOn' :readOnly="true" />
                            </div>
                        </div>
                        <div class="na-field">
                            <div class="na-field-label">Erstellt von:</div>
                            <div class="na-field-value">
                                <DxTextBox :value='suchfeldDetail.SufCreatedBy' :readOnly="true" />
                            </div>
                        </div>


                        <div class="na-field">
                            <div class="na-field-label">Bild:</div>
                            <div class="na-field-value">
                                <DxFileUploader accept="image/jpg"
                                                :multiple="false"
                                                upload-mode="instantly"
                                                @value-changed="onUploadingImage" />
                            </div>
                        </div>
                        <div class="na-field">
                            <div class="na-field-label"></div>
                            <div class="na-field-value">
                                <img :src="sufImage" class="na-image" />
                            </div>
                        </div>
                    </div>
                </DxItem>
                <DxItem title="Feeds">
                    <DxDataGrid :data-source="rssSuchfeldList"
                                key-expr="RssId"
                                :remote-operations="false"
                                :allow-column-reordering="true"
                                :row-alternation-enabled="true"
                                :show-borders="true">
                        <DxEditing :allow-updating="true"
                                   :allow-adding="false"
                                   :allow-deleting="false"
                                   select-text-on-edit-start="true"
                                   start-edit-action="click"
                                   mode="cell" />
                        <DxColumn data-field="Selected" caption="Selected" data-type="boolean" :width="120" />
                        <DxColumn data-field="RssName" caption="Feed" data-type="string" :allowEditing="false" />
                    </DxDataGrid>

                </DxItem>
            </DxTabPanel>
            <div class="na-buttons-row">
                <div>
                    <DxButton :width="120"
                              text="Save"
                              :type="saveButtonType"
                              :disabled="saveButtonDisabled"
                              styling-mode="contained"
                              @click="onSaveClick($event)" />
                </div>
                <div>
                    <DxButton :width="120"
                              text="Delete"
                              type="danger"
                              styling-mode="contained"
                              @click="onDeleteClick($event)" />
                </div>
                <div>
                    <DxButton text="Extract Keywords"
                              type="normal"
                              styling-mode="contained"
                              @click="onExtractKeywords($event)" />
                </div>

                <div>
                    <DxButton :width="120"
                              text="Back"
                              type="back"
                              styling-mode="contained"
                              @click="onCancelClick($event)" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { DxTextBox } from 'devextreme-vue/text-box'
    import { DxButton } from 'devextreme-vue/button'
    import { DxCheckBox } from 'devextreme-vue/check-box'
    import { DxDataGrid, DxColumn, DxEditing } from 'devextreme-vue/data-grid'
    //import notify from 'devextreme/ui/notify'
    import { DxDateBox } from 'devextreme-vue/date-box'
    import { DxTabPanel } from 'devextreme-vue/tab-panel'
    import { DxTagBox } from 'devextreme-vue/tag-box'
    import { DxHtmlEditor, DxToolbar, DxItem } from 'devextreme-vue/html-editor'
    import { DxFileUploader } from 'devextreme-vue/file-uploader'
    import $ from 'jquery';
    import { confirm } from "devextreme/ui/dialog"
    import notify from 'devextreme/ui/notify'
    import '../assets/detailForm.less';

    export default {
        name: 'RssFeedDetail',
        components: {
            DxButton,
            DxTextBox,
            DxTabPanel,
            DxDateBox,
            DxDataGrid,
            DxColumn,
            DxEditing,
            DxTagBox,
            DxHtmlEditor,
            DxToolbar,
            DxItem,
            DxFileUploader,
            DxCheckBox
        },
        data() {

            return { 
                isSaving: false
            };
        },
        computed: {
            suchfeldDetail() {
                return this.$store.state.suchfeldStore.suchfeldDetailVx
            },
            suchfeldDetailIsLoading () {
                return this.$store.state.suchfeldStore.suchfeldDetailIsLoading
            },
            suchfeldDetailText() {
                return JSON.stringify(this.$store.state.suchfeldStore.suchfeldDetail)
            },
            rssSuchfeldList() {
                return this.$store.state.suchfeldStore.rssSuchfeldList
            },
            rssSuchfeldListText() {
                return JSON.stringify(this.$store.state.suchfeldStore.rssSuchfeldList)
            },
            saveButtonType() {
                return this.changed ? "success" : "normal"
            },
            saveButtonDisabled() {
                return this.changed ? false : true
            },
            suchfeldDeleted() {
                return JSON.stringify(this.$store.state.suchfeldStore.suchfeldDeleted)
            },
            sufImage() {
                return this.$store.state.suchfeldStore.sufImage
            },
            allKeyWords() {
                return []
            },
            keyWords: {
                get: function () {
                    var kws = this.suchfeldDetail.SufKeyWords;
                    if (kws && kws.length > 0) {
                        return JSON.parse(kws)
                    }
                    return []
                },
                set: function (newValue) {
                    this.suchfeldDetail.SufKeyWords = JSON.stringify(newValue)
                }
            },
            changed() {
                return this.$store.state.suchfeldStore.suchfeldDetailChanged || this.$store.state.suchfeldStore.rssSuchfeldListChanged
            }
        }, 
        props: {
            litId: {
                type: [Number],
                required: true,
                default: 0
            },
        },
        watch: {
            rssFeedUpdated: function () {

            },
            suchfeldDetailText: function (newVal, oldVal) {
                if (oldVal != "{}" && !this.suchfeldDetailIsLoading && oldVal != newVal) {
                    this.$store.state.suchfeldStore.suchfeldDetailChanged = true
                }
            },
            rssSuchfeldListText: function (newVal, oldVal) {
                if (oldVal != "[]"   && oldVal != newVal) {
                    this.$store.state.suchfeldStore.rssSuchfeldListChanged = true
                }
            },
            suchfeldDeleted: function () {
                if (this.$store.state.suchfeldStore.suchfeldDeleted) {
                    $("form").attr("action", window.location.pathname + "?action=return").submit()
                }
            },
            saveButtonType() {
                return this.changed
                    ? "success" : "normal"
            },
            saveButtonDisabled() {
                return this.changed
                    ? false : true
            },
            changed: function (newVal) {
                if (!newVal && this.isSaving) {
                    this.isSaving = false
                    notify("The changes were saved successfully")
                }
            },
        },
        getter: {
            get() {

            },
        },
        created: function () {
            let vm = this
            this.$store.dispatch("getSuchfeldDetailVx", { litId: vm.litId })
            this.$store.dispatch("getAllRssFeedInfosForSuchfeld", { litId: vm.litId })
        },
        methods: {
            onCancelClick() {
                $("form").attr("action", window.location.pathname + "?action=return").submit()
            },
            onSaveClick() {
                this.isSaving = true
                this.$store.dispatch("saveSuchfeldDetail")
                this.$store.dispatch("saveRssSuchfeldList", { litId: this.suchfeldDetail.LitId })
            },
            onExtractKeywords() {
                this.$store.dispatch("extractSuchfeldKeywords")
            },
            onDeleteClick() {
                let result = confirm("Sind Sie sicher, dass Sie das Suchfeld löschen möchten? Falls das Suchfeld schon ausgewählt wurde, lässt es sich nicht löschen.", "Löschen bestätigen");
                result.then((dialogResult) => {
                    if (dialogResult) {
                        this.$store.dispath("deleteSuchfeld", { litId: this.suchfeldDetail.LitId })
                    }
                });
            },
            onCustomItemCreating(e) {
                {
                    console.log(e)
                    if (!e.customItem) {
                        e.customItem = e.text;
                    }
                }
            },
            onUploadingImage(e) {
                let reader = new FileReader()
                if (e.value && e.value.length > 0) {
                    reader.readAsDataURL(e.value[0])
                    reader.onload = function () {
                        this.self.suchfeldDetail.SufImageUri = this.reader.result
                        this.self.$store.state.suchfeldStore.sufImage = this.reader.result
                        this.self.$store.state.suchfeldStore.suchfeldDetailChanged = true
                        this.component.reset()
                    }.bind({ reader, self: this, component: e.component });
                }
            }
        }
    }


</script>
<style scoped>

    div {
        text-align: left;
    }

    .options {
        margin-top: 20px;
        padding: 20px;
        background-color: rgba(191, 191, 191, 0.15);
        box-sizing: border-box;
        width: 100%;
    }

    .na-link {
        cursor: pointer;
    }

    .naKeyWords {
        width: 700px;
    }


    form .na-field .na-field-value {
        max-width: initial;
    }

    .na-field-value-static, .na-field-value:not(.dx-switch):not(.dx-checkbox):not(.dx-button) {
        width: 700px;
    }

    .na-image {
        max-width: 700px;
    }
</style>


